import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const MACHINES = [
  {
    name: 'Snack & Beverage Combo',
    fit: 'Best for: Offices, Break Rooms, Lobbies',
    features: [
      'Wide selection of snacks and drinks',
      'Cashless payment ready',
      'Energy-efficient LED display',
      'ADA-compliant design',
    ],
  },
  {
    name: 'Cold Beverage Machine',
    fit: 'Best for: Gyms, Apartments, Schools',
    features: [
      'Refrigerated for ice-cold drinks',
      'High-capacity bottle storage',
      'Digital temperature monitoring',
      'Quick-vend technology',
    ],
  },
  {
    name: 'Healthy Options Machine',
    fit: 'Best for: Medical Offices, Fitness Centers',
    features: [
      'Curated healthy snacks & beverages',
      'Allergen-friendly selections',
      'Fresh food capable',
      'Nutritional info display',
    ],
  },
  {
    name: 'Smart Cooler',
    fit: 'Best for: Gyms, Hotels, Medical Centers',
    features: [
      'Modern touchscreen interface',
      'Real-time inventory tracking',
      'Fresh food & cold beverage ready',
      'Perfect for gyms, hotels & medical centers',
    ],
  },
];

const sectionVariants = {
  hidden: { opacity: 0, y: 18 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export const Machines = () => {
  return (
    <section id="machines" className="scroll-mt-24 bg-kv-mist py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.25 }}
          className="text-center mb-12 sm:mb-16"
        >
          <span className="text-xs uppercase tracking-[0.22em] text-kv-gold font-sans font-semibold mb-4 block">
            Our Machines
          </span>
          <h2 className="text-3xl sm:text-4xl font-display tracking-tight text-kv-black-2">
            Built for Every Space
          </h2>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {MACHINES.map((machine) => (
            <motion.div
              key={machine.name}
              variants={cardVariants}
              data-testid={`machine-card-${machine.name.toLowerCase().replace(/\s+/g, '-')}`}
              className="group machine-card-underline rounded-2xl border border-black/8 bg-white p-6 sm:p-8 shadow-[0_1px_0_rgba(17,17,20,0.04),0_10px_30px_rgba(17,17,20,0.05)] hover:-translate-y-1 transition-transform"
            >
              <h3 className="text-xl sm:text-2xl font-display text-kv-black-2 mb-2">
                {machine.name}
              </h3>
              <p className="text-xs uppercase tracking-[0.15em] text-kv-gold font-sans font-semibold mb-6">
                {machine.fit}
              </p>
              <ul className="space-y-3">
                {machine.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-3 text-sm text-gray-600 font-sans">
                    <Check className="h-4 w-4 text-kv-gold mt-0.5 shrink-0" />
                    {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
